<template>
    <div class="slider scroll-reveal animate__animated" data-animation="bounceInUp">
        <h2 class="slider__title">{{ slideTitles[currentSlide] }}</h2>
        <h3 v-if="currentSlide != (slideTitles.length - 1)" class="slider__subtitle">{{ $t('game-results.score-number') }}: {{ slideScore }}/{{ totalScore }}</h3>

        <vueper-slides @slide="updateSlideInfo($event)" :infinite="false" :disableArrowsOnEdges="true" :bullets="false" :gap="3" class="no-shadow">
            <vueper-slide v-for="(item, index) in slideTitles.length" :key="index">
                <template #content>
                    <div class="slider__item">
                        <img v-if="whatWasGoodMessages[currentSlide]" src="@/assets/images/love.svg" :alt="$t('game-results.what-was-good')" />
                        <h3 v-if="whatWasGoodMessages[currentSlide]" class="slider__subtitle">{{ $t('game-results.what-was-good') }}</h3>
                        <ul v-if="whatWasGoodMessages[currentSlide]" class="slider__list">
                            <li v-for="(message, index) in whatWasGoodMessages[currentSlide]" :key="index" class="slider__list-item">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.5302 6.40953C19.8192 6.68275 19.9879 7.05956 19.9991 7.45711C20.0104 7.85466 19.8633 8.2404 19.5902 8.52953L11.0902 17.5295C10.9524 17.6751 10.7869 17.7916 10.6033 17.8722C10.4198 17.9527 10.2219 17.9957 10.0215 17.9985C9.82109 18.0013 9.62214 17.9639 9.43641 17.8885C9.25068 17.8131 9.08195 17.7012 8.94018 17.5595L4.44018 13.0595C4.17522 12.7752 4.03097 12.3991 4.03783 12.0105C4.04469 11.6219 4.20211 11.2511 4.47694 10.9763C4.75176 10.7015 5.12253 10.544 5.51114 10.5372C5.89974 10.5303 6.27583 10.6746 6.56018 10.9395L9.97018 14.3475L17.4102 6.46953C17.6834 6.18052 18.0602 6.01185 18.4578 6.0006C18.8553 5.98935 19.2411 6.13644 19.5302 6.40953Z" fill="#FE8053"/>
                                </svg>
                                {{ message.message.replace(/XX/g, leftoverBudget) }}
                            </li>
                        </ul>

                        <img v-if="whatCouldImproveMessages[currentSlide]" src="@/assets/images/nerd.svg" :alt="$t('game-results.what-could-improve')" />
                        <h3 v-if="whatCouldImproveMessages[currentSlide]" class="slider__subtitle">{{ $t('game-results.what-could-improve') }}</h3>
                        <ul v-if="whatCouldImproveMessages[currentSlide]" class="slider__list">
                            <li v-for="(message, index) in whatCouldImproveMessages[currentSlide]" :key="index" class="slider__list-item">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.5302 6.40953C19.8192 6.68275 19.9879 7.05956 19.9991 7.45711C20.0104 7.85466 19.8633 8.2404 19.5902 8.52953L11.0902 17.5295C10.9524 17.6751 10.7869 17.7916 10.6033 17.8722C10.4198 17.9527 10.2219 17.9957 10.0215 17.9985C9.82109 18.0013 9.62214 17.9639 9.43641 17.8885C9.25068 17.8131 9.08195 17.7012 8.94018 17.5595L4.44018 13.0595C4.17522 12.7752 4.03097 12.3991 4.03783 12.0105C4.04469 11.6219 4.20211 11.2511 4.47694 10.9763C4.75176 10.7015 5.12253 10.544 5.51114 10.5372C5.89974 10.5303 6.27583 10.6746 6.56018 10.9395L9.97018 14.3475L17.4102 6.46953C17.6834 6.18052 18.0602 6.01185 18.4578 6.0006C18.8553 5.98935 19.2411 6.13644 19.5302 6.40953Z" fill="#FE8053"/>
                                </svg>
                                {{ message.message.replace(/XX/g, leftoverBudget) }}
                            </li>
                        </ul>
                    </div>
                </template>
            </vueper-slide>

            <template #arrow-right>
                <div class="btn btn--option">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0001 7.99991L11.0001 15.9999L19.0001 23.9999" stroke="#F88C50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </template>
            <template #arrow-left>
                <div class="btn btn--option">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0001 7.99991L11.0001 15.9999L19.0001 23.9999" stroke="#F88C50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </template>
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
    name: 'ResultsDuringBuilding',
    components: {
        VueperSlides,
        VueperSlide
    },
    inject: ['buildReport', 'scrollTrigger', 'addObserver'],
    data() {
        return {
            report: this.buildReport,
            slideTitles: [
                this.$t('game-results.during-building.sustainability-text'),
                this.$t('game-results.during-building.energy-efficiency-text'),
                this.$t('game-results.during-building.budget-text'),
            ],
            currentSlide: 0,
            currentSlideScore: null
        }
    },
    computed: {
        totalScore() {
            if (this.report) {
                return this.report.TotalScore;
            } else {
                return false;
            }
        },
        slideScore() {
            if (this.currentSlideScore == null && this.report) {
                return this.report.SScore;
            } else {
                return this.currentSlideScore;
            }
        },
        whatWasGoodMessages() {
            let messages = [];

            if (this.report) {
                if (this.report.SWhatWasGood && this.report.SWhatWasGood.length) {
                    messages.push(this.report.SWhatWasGood);
                }

                if (this.report.EEWhatWasGood && this.report.EEWhatWasGood.length) {
                    messages.push(this.report.EEWhatWasGood);
                }

                if (this.report.BWhatWasGood && this.report.BWhatWasGood.length) {
                    messages.push(this.report.BWhatWasGood);
                }
            }

            return messages;
        },
        whatCouldImproveMessages() {
            let messages = [];

            if (this.report) {
                if (this.report.SWhatCouldImprove && this.report.SWhatCouldImprove.length) {
                    messages.push(this.report.SWhatCouldImprove);
                }

                if (this.report.EEWhatCouldImprove && this.report.EEWhatCouldImprove.length) {
                    messages.push(this.report.EEWhatCouldImprove);
                }

                if (this.report.BWhatCouldImprove && this.report.BWhatCouldImprove.length) {
                    messages.push(this.report.BWhatCouldImprove);
                }
            }

            return messages;
        },
        leftoverBudget() {
            let budget = null;

            if (this.report) {
                budget = Number(this.report.LeftoverBudget.value).toLocaleString('hr');
            }

            return budget;
        }
    },
    methods: {
        updateSlideInfo(params) {
            this.currentSlide = params.currentSlide.index;

            if (params.currentSlide.index == 0) {
                this.currentSlideScore = this.report.SScore;
            } else if (params.currentSlide.index == 1) {
                this.currentSlideScore = this.report.EEScore;
            } else {
                this.currentSlideScore = null;
            }
        }
    },
    mounted() {
        this.scrollTrigger('.scroll-reveal', {
            rootMargin: '-50px'
        });
    }
}
</script>
